import { HttpClient } from '../HttpClient';
/**
 * * Get Employee Lookup
 */

export const GetEmployeeLookup = async (id, { PageNumber = 1, RowsPerPage = 50, SortColumn = 'lastName', SearchString, FilterBy }) => {
  try {
    SearchString = encodeURIComponent(SearchString);
    const searchParams = {
      SearchString,
      FilterBy,
    };
    const { data } = await HttpClient.get(`api/projects/${id}/EmployeeLookup`, {
      params: {
        PageNumber,
        RowsPerPage,
        SortColumn,
        ...(SearchString && SearchString !== undefined && FilterBy ? searchParams : null),
      },
    });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
